import { useState, useEffect } from 'react';

// Import logos
import pahrmasun from "../assets/schools/pharma/placementlogo/sun.webp";
import pahrmaastellas from "../assets/schools/pharma/placementlogo/astellas.webp";
import pahrmaaurbindo from "../assets/schools/pharma/placementlogo/aurobindo.webp";
import pahrmacipla from "../assets/schools/pharma/placementlogo/cipla.webp";
import pahrmadrreddy from "../assets/schools/pharma/placementlogo/drreddy.webp";
import pahrmaglenmark from "../assets/schools/pharma/placementlogo/glenmark.webp";
import pahrmaintas from "../assets/schools/pharma/placementlogo/intas.webp";
import pahrmajohnson from "../assets/schools/pharma/placementlogo/johnson.webp";
import pahrmalupin from "../assets/schools/pharma/placementlogo/lupin.webp";
import pahrmapf from "../assets/schools/pharma/placementlogo/pf.webp";
import pahrmatorrent from "../assets/schools/pharma/placementlogo/torrent.webp";

const PharmaLogoSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const logos = [
    { src: pahrmasun, name: "Sun Pharma" },
    { src: pahrmaastellas, name: "Astellas" },
    { src: pahrmaaurbindo, name: "Aurobindo" },
    { src: pahrmacipla, name: "Cipla" },
    { src: pahrmadrreddy, name: "Dr. Reddy's" },
    { src: pahrmaglenmark, name: "Glenmark" },
    { src: pahrmaintas, name: "Intas" },
    { src: pahrmajohnson, name: "Johnson & Johnson" },
    { src: pahrmalupin, name: "Lupin" },
    { src: pahrmapf, name: "Pfizer" },
    { src: pahrmatorrent, name: "Torrent Pharma" }
  ];

  // Number of logos to show at once (responsive)
  const getVisibleCount = () => {
    if (typeof window !== 'undefined') {
      if (window.innerWidth < 640) return 1;
      if (window.innerWidth < 768) return 2;
      if (window.innerWidth < 1024) return 3;
      return 5;
    }
    return 5; // Default for server-side rendering
  };

  const [visibleCount, setVisibleCount] = useState(getVisibleCount());

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setVisibleCount(getVisibleCount());
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Auto-slide functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => 
        prevIndex + 1 >= logos.length ? 0 : prevIndex + 1
      );
    }, 3000);
    
    return () => clearInterval(interval);
  }, [logos.length]);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex + 1 >= logos.length ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex - 1 < 0 ? logos.length - 1 : prevIndex - 1
    );
  };

  const getVisibleLogos = () => {
    const visibleLogos = [];
    for (let i = 0; i < visibleCount; i++) {
      const index = (currentIndex + i) % logos.length;
      visibleLogos.push(logos[index]);
    }
    return visibleLogos;
  };

  return (
    <div className="w-full py-8 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-2xl font-bold text-center mb-8 text-gray-800">Our Placement Partners</h2>
        
        <div className="relative">
          {/* Previous button */}
          <button 
            onClick={prevSlide} 
            className="absolute left-0 top-1/2 -translate-y-1/2 bg-white p-2 rounded-full shadow-md z-10 hover:bg-gray-100"
            aria-label="Previous logos"
          >
            <svg className="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          
          {/* Logo container */}
          <div className="overflow-hidden py-4">
            <div className="flex items-center justify-center gap-8">
              {getVisibleLogos().map((logo, index) => (
                <div key={index} className="flex flex-col items-center">
                  <div className="bg-white p-4 rounded-lg shadow-sm flex items-center justify-center h-24 w-36">
                    <img 
                      src={logo.src} 
                      alt={`${logo.name} logo`} 
                      className="max-h-16 max-w-full object-contain"
                    />
                  </div>
                  <p className="mt-2 text-sm text-gray-600 text-center">{logo.name}</p>
                </div>
              ))}
            </div>
          </div>
          
          {/* Next button */}
          <button 
            onClick={nextSlide} 
            className="absolute right-0 top-1/2 -translate-y-1/2 bg-white p-2 rounded-full shadow-md z-10 hover:bg-gray-100"
            aria-label="Next logos"
          >
            <svg className="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
        
        {/* Indicator dots */}
        <div className="flex justify-center mt-6">
          {logos.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`mx-1 h-2 w-2 rounded-full ${
                index === currentIndex ? 'bg-blue-600' : 'bg-gray-300'
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PharmaLogoSlider;